import { AuthWrapper, SettingsPage } from "@risalabs_frontend_org/auth-wrapper";
import "@risalabs_frontend_org/auth-wrapper/styles.css";
import { type ReactNode } from "react";
import { Provider as PharmacyReduxProvider } from "react-redux";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import "./App.scss";
import DevAutoSignIn from "./medonc/components/devAutoSignIn/devAutoSignIn";
import pharmacyStore from "./pharmacy/redux/store/store";

import ErrorPage from "./medonc/components/errorPage/errorPage";
import ProtectedConfigRoute from "./medonc/components/protectedConfigRoute/protectedConfigRoute";
import Home from "./medonc/pages/home/Home";
import { isDevBypassEnabled } from "./medonc/utils/configAccess";

import ClaimsConfigurations from "./medonc/pages/configurations/ClaimsConfigurations";
import DefaultConfigRedirect from "./medonc/pages/configurations/DefaultConfigRedirect";

import Configurations from "./medonc/pages/configurations/configurations";

import AgenticAuthOnFileConfiguration from "./medonc/pages/configurations/pages/agenticAuthOnFileConfiguration/agenticAuthOnFileConfiguration";
import AuthorizationLetterConfiguration from "./medonc/pages/configurations/pages/authorizationLetterConfiguration/authorizationLetterConfiguration";
import DataMigration from "./medonc/pages/configurations/pages/dataMigration/dataMigration";
import DocumentsToAttach from "./medonc/pages/configurations/pages/documentsConfiguration/documentsToAttach";
import DocumentStudio from "./medonc/pages/configurations/pages/documentStudio/documentStudio";
import DxCodeConfig from "./medonc/pages/configurations/pages/dxCodeConfig/dxCodeConfig";
import EmailPasswordConfiguration from "./medonc/pages/configurations/pages/emailPasswordConfiguration/emailPasswordConfiguration";
import FormConfig from "./medonc/pages/configurations/pages/formsConfiguration/formConfig";
import FormConfigurationLayout from "./medonc/pages/configurations/pages/formsConfiguration/formConfigurationLayout";
import SingleFormConfiguration from "./medonc/pages/configurations/pages/formsConfiguration/singleFormConfiguration/singleFormConfiguration";
import GiRpaConfiguration from "./medonc/pages/configurations/pages/giRpaConfiguration/giRpaConfiguration";
import HistoricNarConfigLayout from "./medonc/pages/configurations/pages/historicNarConfig/historicNarConfigLayout";
import MedicineNameConfiguration from "./medonc/pages/configurations/pages/medicineNameConfiguration/medicineNameConfiguration";
import NarAgentGridLayout from "./medonc/pages/configurations/pages/narAgentGrid/narAgentGridLayout";
import NarConfigurationLayout from "./medonc/pages/configurations/pages/narConfiguration/narConfigurationLayout";
import OptionsConfiguration from "./medonc/pages/configurations/pages/optionsConfiguration/optionsConfiguration";
import OrderAssignmentConfiguration from "./medonc/pages/configurations/pages/orderAssignmentConfiguration/orderAssignmentConfiguration";
import PaFormConfiguration from "./medonc/pages/configurations/pages/paFormConfiguration/paFormConfiguration";
import ClinicalQuestionnaire from "./medonc/pages/configurations/pages/pharmaPaConfiguration/pages/clinicalQuestionnaire/clinicalQuestionnaire";
import DrugsConfiguration from "./medonc/pages/configurations/pages/pharmaPaConfiguration/pages/drugConfig/drugsConfig";
import PayerConfiguration from "./medonc/pages/configurations/pages/pharmaPaConfiguration/pages/payerConfiguration/payerConfiuratiom";
import PbmConfiguration from "./medonc/pages/configurations/pages/pharmaPaConfiguration/pages/pbmConfiguration/pbmConfiguration";
import ProviderList from "./medonc/pages/configurations/pages/pharmaPaConfiguration/pages/providerList/providerList";
import SendToPlanConfig from "./medonc/pages/configurations/pages/pharmaPaConfiguration/pages/sendToPlanConfig/sendToPlanConfig";
import PharmaPaConfigurationLayout from "./medonc/pages/configurations/pages/pharmaPaConfiguration/pharmaPaConfigurationLayout";
import PrescriptionParsingConfiguration from "./medonc/pages/configurations/pages/prescriptionParsingConfiguration/prescriptionParsingConfiguration";
import RpaConfiguration from "./medonc/pages/configurations/pages/rpaConfiguration/rpaConfiguration";

import ClientConfiguration from "./medonc/pages/clientConfiguration/clientConfiguration";
import HealthFacilityConfiguration from "./medonc/pages/configurations/pages/healthFacilityConfiguration/healthFacilityConfiguration";
import CredentialsConfig from "./medonc/pages/credentialsConfigration/credentialsConfig";

import CallingConfiguration from "./pharmacy/pages/configurations/pages/callingConfiguration/callingConfiguration";
import PharmacyDocumentsToAttach from "./pharmacy/pages/configurations/pages/documentsConfiguration/documentsToAttach";
import FirstStpBucketing from "./pharmacy/pages/configurations/pages/firstStpBucketing/firstStpBucketing";
import PharmacyFormConfig from "./pharmacy/pages/configurations/pages/formsConfiguration/formConfig";
import PharmacyFormConfigurationLayout from "./pharmacy/pages/configurations/pages/formsConfiguration/formConfigurationLayout";
import PharmacySingleFormConfiguration from "./pharmacy/pages/configurations/pages/formsConfiguration/singleFormConfiguration/singleFormConfiguration";
import PharmacyHealthFacilityConfiguration from "./pharmacy/pages/configurations/pages/healthFacilityConfiguration/healthFacilityConfiguration";
import MedicalNecessityConfiguration from "./pharmacy/pages/configurations/pages/medicalNecessityConfiguration/medicalNecessityConfiguration";
import MedicationList from "./pharmacy/pages/configurations/pages/medicationList/medicationList";
import PharmacyMedicineNameConfiguration from "./pharmacy/pages/configurations/pages/medicineNameConfiguration/medicineNameConfiguration";
import PharmacyPaFormConfiguration from "./pharmacy/pages/configurations/pages/paFormConfiguration/paFormConfiguration";
import PharmacyClinicalQuestionnaire from "./pharmacy/pages/configurations/pages/pharmaPaConfiguration/pages/clinicalQuestionnaire/clinicalQuestionnaire";
import PharmacyDrugsConfiguration from "./pharmacy/pages/configurations/pages/pharmaPaConfiguration/pages/drugConfig/drugsConfig";
import PharmacyPbmConfiguration from "./pharmacy/pages/configurations/pages/pharmaPaConfiguration/pages/pbmConfiguration/pbmConfiguration";
import PharmacyProviderList from "./pharmacy/pages/configurations/pages/pharmaPaConfiguration/pages/providerList/providerList";
import PharmacySendToPlanConfig from "./pharmacy/pages/configurations/pages/pharmaPaConfiguration/pages/sendToPlanConfig/sendToPlanConfig";
import PharmacyPharmaPaConfigurationLayout from "./pharmacy/pages/configurations/pages/pharmaPaConfiguration/pharmaPaConfigurationLayout";
import PocAssignment from "./pharmacy/pages/configurations/pages/pocAssignment/pocAssignment";
import PocConfiguration from "./pharmacy/pages/configurations/pages/pocConfiguration/pocConfiguration";
import PocReassignment from "./pharmacy/pages/configurations/pages/pocReassignment/pocReassignment";
import PharmacyPrescriptionParsingConfiguration from "./pharmacy/pages/configurations/pages/prescriptionParsingConfiguration/prescriptionParsingConfiguration";
import ProviderOptionsConfiguration from "./pharmacy/pages/configurations/pages/providerOptionsConfiguration/providerOptionsConfiguration";
import ConditionList from "./pharmacy/pages/configurations/pages/validationFunnel/pages/conditionList/conditionList";
import FirstStpLogic from "./pharmacy/pages/configurations/pages/validationFunnel/pages/firstStpLogic";
import FormMatrix from "./pharmacy/pages/configurations/pages/validationFunnel/pages/formMatrix/formMatrix";
import PlayGround from "./pharmacy/pages/configurations/pages/validationFunnel/pages/playGround/playGround";
import ValidationFunnelValidationRules from "./pharmacy/pages/configurations/pages/validationFunnel/pages/validationRules";
import ValidationFunnel from "./pharmacy/pages/configurations/pages/validationFunnel/validationFunnel";

import * as firebaseDevConfig from "./shared/api/firebase/config-dev.json";
import * as firebaseProdConfig from "./shared/api/firebase/config-prod.json";

const isProduction = process.env.REACT_APP_ENV === "production";
const firebaseConfig = isProduction ? firebaseProdConfig : firebaseDevConfig;
const BACKEND_SERVICE_URL = isProduction
  ? "https://apis.risalabs.ai/backend-service/"
  : "https://apis-dev.risalabs.ai/backend-service/";

const configChildRoutes = () => (
  <>
    <Route
      index
      element={<Navigate to="agentic-auth-on-file-configuration" replace />}
    />
    <Route path="documents-configuration" element={<DocumentsToAttach />} />
    <Route path="rpa-configuration" element={<RpaConfiguration />} />
    <Route path="form-configuration" element={<FormConfigurationLayout />}>
      <Route index element={<Navigate to="form-config" replace />} />
      <Route path="form-config" element={<FormConfig />} />
      <Route path="form-config/:id" element={<SingleFormConfiguration />} />
    </Route>
    <Route path="pa-form-configuration" element={<PaFormConfiguration />} />
    <Route
      path="medicine-name-configuration"
      element={<MedicineNameConfiguration />}
    />
    <Route
      path="prescription-parsing-configuration"
      element={<PrescriptionParsingConfiguration />}
    />
    <Route
      path="pharma-pa-configuration"
      element={<PharmaPaConfigurationLayout />}
    >
      <Route index element={<Navigate to="send-to-plan-config" replace />} />
      <Route path="send-to-plan-config" element={<SendToPlanConfig />} />
      <Route path="pbm-configurations" element={<PbmConfiguration />} />
      <Route path="drugs-configuration" element={<DrugsConfiguration />} />
      <Route path="clinical-questionaire" element={<ClinicalQuestionnaire />} />
    </Route>
    <Route path="client-configuration" element={<ClientConfiguration />} />
    <Route path="provider-list" element={<ProviderList />} />
    <Route path="payer-config" element={<PayerConfiguration />} />
    <Route path="nar-agent-grid" element={<NarAgentGridLayout />} />
    <Route path="historic-nar-config" element={<HistoricNarConfigLayout />} />
    <Route path="nar-configuration" element={<NarConfigurationLayout />} />
    <Route
      path="health-facility"
      element={<HealthFacilityConfiguration variant="med_onc" />}
    />
    <Route path="gi-configuration" element={<GiRpaConfiguration />} />
    <Route
      path="email-password-configuration"
      element={<EmailPasswordConfiguration />}
    />
    <Route path="dx-code-config" element={<DxCodeConfig />} />
    <Route path="options-configuration" element={<OptionsConfiguration />} />
    <Route
      path="authorization-letter-configuration"
      element={<AuthorizationLetterConfiguration />}
    />
    <Route
      path="agentic-auth-on-file-configuration"
      element={<AgenticAuthOnFileConfiguration />}
    />
    <Route
      path="auto-assignment-configuration"
      element={<OrderAssignmentConfiguration />}
    />
    {isProduction && (
      <Route path="data-migration" element={<DataMigration />} />
    )}
  </>
);

const withPharmacyStore = (element: ReactNode) => (
  <PharmacyReduxProvider store={pharmacyStore}>{element}</PharmacyReduxProvider>
);

const pharmacyConfigChildRoutes = () => (
  <>
    <Route index element={<Navigate to="documents-configuration" replace />} />
    <Route
      path="documents-configuration"
      element={<PharmacyDocumentsToAttach />}
    />
    <Route
      path="medical-necessity-configuration"
      element={<MedicalNecessityConfiguration />}
    />
    <Route
      path="health-facility"
      element={<PharmacyHealthFacilityConfiguration />}
    />
    <Route
      path="form-configuration"
      element={<PharmacyFormConfigurationLayout />}
    >
      <Route index element={<Navigate to="form-config" replace />} />
      <Route path="form-config" element={<PharmacyFormConfig />} />
      <Route
        path="form-config/:id"
        element={<PharmacySingleFormConfiguration />}
      />
    </Route>
    <Route
      path="pa-form-configuration"
      element={<PharmacyPaFormConfiguration />}
    />
    <Route
      path="medicine-name-configuration"
      element={<PharmacyMedicineNameConfiguration />}
    />
    <Route
      path="prescription-parsing-configuration"
      element={<PharmacyPrescriptionParsingConfiguration />}
    />
    <Route
      path="pharma-pa-configuration"
      element={<PharmacyPharmaPaConfigurationLayout />}
    >
      <Route index element={<Navigate to="send-to-plan-config" replace />} />
      <Route
        path="send-to-plan-config"
        element={<PharmacySendToPlanConfig />}
      />
      <Route path="pbm-configurations" element={<PharmacyPbmConfiguration />} />
      <Route
        path="drugs-configuration"
        element={<PharmacyDrugsConfiguration />}
      />
      <Route
        path="clinical-questionaire"
        element={<PharmacyClinicalQuestionnaire />}
      />
    </Route>
    <Route path="validation-funnel" element={<ValidationFunnel />}>
      <Route index element={<Navigate to="first-stp-logic" replace />} />
      <Route path="first-stp-logic" element={<FirstStpLogic />} />
      <Route path="form-matrix" element={<FormMatrix />} />
      <Route path="condition-list" element={<ConditionList />} />
      <Route path="playground" element={<PlayGround />} />
      <Route
        path="validation-rules"
        element={<ValidationFunnelValidationRules />}
      />
    </Route>
    <Route path="provider-list" element={<PharmacyProviderList />} />
    <Route path="medication-list" element={<MedicationList />} />
    <Route
      path="provider-options-configuration"
      element={<ProviderOptionsConfiguration />}
    />
    <Route path="first-stp-bucketing" element={<FirstStpBucketing />} />
    <Route path="calling-configuration" element={<CallingConfiguration />} />
    <Route path="poc-assignment" element={<PocAssignment />} />
    <Route path="poc-reassignment" element={<PocReassignment />} />
    <Route path="poc-configuration" element={<PocConfiguration />} />
  </>
);

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Home />}>
      <Route index element={<Navigate to="/configurations" replace />} />
      <Route
        path="configurations"
        element={
          <ProtectedConfigRoute>
            <Outlet />
          </ProtectedConfigRoute>
        }
      >
        <Route index element={<DefaultConfigRedirect />} />
        <Route
          path="med_onc"
          element={
            <ProtectedConfigRoute requiredSection="med_onc">
              <Configurations variant="med_onc" />
            </ProtectedConfigRoute>
          }
        >
          {configChildRoutes()}
        </Route>
        <Route
          path="pharmacy"
          element={
            <ProtectedConfigRoute requiredSection="pharmacy">
              {withPharmacyStore(<Configurations variant="pharmacy" />)}
            </ProtectedConfigRoute>
          }
        >
          {pharmacyConfigChildRoutes()}
        </Route>
        <Route
          path="claims/*"
          element={
            <ProtectedConfigRoute requiredSection="claims">
              <ClaimsConfigurations />
            </ProtectedConfigRoute>
          }
        />
        <Route
          path="common"
          element={
            <ProtectedConfigRoute>
              <Configurations variant="common" />
            </ProtectedConfigRoute>
          }
        >
          <Route index element={<Navigate to="document-studio" replace />} />
          <Route path="document-studio" element={<DocumentStudio />} />
          <Route
            path="health-facility"
            element={
              <ProtectedConfigRoute requireSuperAdmin>
                <HealthFacilityConfiguration variant="common" />
              </ProtectedConfigRoute>
            }
          />
          <Route
            path="credentials-configuration"
            element={
              <ProtectedConfigRoute requireSuperAdmin>
                <CredentialsConfig />
              </ProtectedConfigRoute>
            }
          />
        </Route>
      </Route>
      <Route path="settings/*" element={<SettingsPage />} />
    </Route>
    <Route path="*" element={<ErrorPage />} />
  </Routes>
);

const App = () => {
  return (
    <BrowserRouter>
      {isDevBypassEnabled() && (
        <DevAutoSignIn firebaseConfig={firebaseConfig} />
      )}
      <AuthWrapper
        config={{
          firebaseConfig,
          apiUrls: {
            backendServiceUrl: BACKEND_SERVICE_URL,
          },
          bearerAuth: {
            username: process.env.REACT_APP_USERNAME,
            password: process.env.REACT_APP_PASSWORD,
          },
          authRedirectPath: "/auth",
          version: process.env.REACT_APP_VERSION,
        }}
      >
        <AppRoutes />
      </AuthWrapper>
    </BrowserRouter>
  );
};

export default App;
